module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/writable-browser.js
// module id = 550
// module chunks = 0